import constants from "../constants";

const {
  FETCH_NEXT_LIST,
  FETCH_NEXT_LIST_DONE,
  INFINITE_SCROLL_LIST,
} = constants;

export default function fetchingNext(state = false, action) {
  switch (action.type) {
    case FETCH_NEXT_LIST:
    case INFINITE_SCROLL_LIST:
      return true;
    case FETCH_NEXT_LIST_DONE: {
      return false;
    }
    default: {
      return state;
    }
  }
}


// WEBPACK FOOTER //
// ./assets/list/reducers/fetchingNext.js